import { autoinject } from "aurelia-dependency-injection";
import { EventAggregator } from "aurelia-event-aggregator";
import { NotificationClientService, NotificationType } from "./notification-client.service";
import type { EntityValidationRule, ValidationResult } from "../../models/validations.models";
import { Messages } from "../../constants/event-messages.constants";
import * as Enumerable from "linq";

@autoinject
export class ValidationsClientService {

    public _validationRules: { [index: number]: EntityValidationRule[] } = {};

    constructor(private notificationService: NotificationClientService, private eventAggregator: EventAggregator) {
        this._validationRules = {};
    }

    public showValidationErrors(validationResult: ValidationResult, prefix: string = null) {
        let fullError = "";
        if (validationResult) {
            Enumerable.from(validationResult.errors).distinct(error => error.message).forEach(error => {

                error.message = error.message.replace(/\r?\n/g, '<br/>');
                fullError += error.message + "<br/>";
            });

            const message = prefix ? (prefix + "<br/>" + fullError) : fullError;
            this.notificationService.show("Validation Error!", message, NotificationType.Error);
        }
        this.eventAggregator.publish(Messages.onValidated, validationResult);
    }
}